import React from 'react'
import { Image, Avatar, message } from 'antd';
import Icon, { UserOutlined, RightOutlined, CloseOutlined, EditOutlined, MobileOutlined, CloseCircleFilled } from '@ant-design/icons';
import intl from 'react-intl-universal';
import moment from 'moment'
import { ReactComponent as desktop } from '../../icons/bbs/tabler_device-analytics.svg';
import { ReactComponent as bird } from '../../icons/bbs/bird.svg';
import { ReactComponent as arrow } from '../../icons/bbs/arrow.svg';
import { ReactComponent as img } from '../../icons/bbs/img.svg';
import { ReactComponent as car } from '../../icons/menuicons/car.svg';
import { ReactComponent as buessiness } from '../../icons/menuicons/buessiness.svg';
import { ReactComponent as house } from '../../icons/menuicons/house.svg';
import { ReactComponent as friends } from '../../icons/bbs/friends.svg';
import { ReactComponent as secondhand } from '../../icons/bbs/secondhand.svg';
import { ReactComponent as job } from '../../icons/bbs/job.svg';
import { ReactComponent as renthome } from '../../icons/bbs/renthome.svg';
import APagination from '../../component/Pagination/Pagination'




import PhoneChatList from '../../component/PhoneChatList/PhoneChatList'

import { timeFormat } from '../../utils'


import ad1 from '../../assets/yellowpage/ad1.png'
// import ad2 from '../../assets/yellowpage/ad2.png'
// import ad3 from '../../assets/yellowpage/ad3.png'

import Nav from '../../component/nav/nav'
import Banner from '../../component/Banner/Banner'
import BreadCrumb from '../../component/BreadCrumb/BreadCrumb'
import Menus from '../../component/Menu/Menu'
import AdConsult from '../../component/AdConsult/AdConsult'
import Foot from '../../component/Foot/Foot'
import LeftTool from '../../component/LeftTool/LeftTool'

import forum from '../../api/bbs'
import merchantsInfo from '../../api/yellow'

import './components/bbs.css'
import PopupSearch from '../../component/PopupSearch/PopupSearch';

import { Search, Dropdown, Popup, Mask, Swiper } from 'antd-mobile';
import { GlobalOutline, MailFill, AppstoreOutline } from 'antd-mobile-icons'

export default class bbsPagesIndex extends React.Component {
    constructor() {
        super()
        this.state = {
            breadArray: [
                {
                    name: intl.get('KUNSHILANYISHOU'),
                    path: '/main',
                    navData: '1'
                },
                {
                    name: intl.get('YISHOULUNTAN'),
                    path: '/bbspages',
                    navData: '2'
                }
            ],
            menuArray: [],
            hotPost: 1,
            hotPostListData: [],
            topData: [],
            hotData: [],
            bbsData: [],
            phoneData: [],
            visible1: false,
            popvisible: false,
            maskVisible: false,
            bbsTitleObj: {
                41: intl.get('SHENGHUOZIXUNGONGXIANG'),
                11: intl.get('BENDIXIANZHIJIAOYI'),
                10: intl.get('KUNZHOUMAICHEBIBEI'),
                9: intl.get('DALIANGBENDISHANGJIA'),
                8: intl.get('ZHUANGYEDICHANPINGTAI'),
                7: intl.get('HAILIANGFANGYUAN'),
                6: intl.get('FEINIMOSHU'),

            },
            newBbsObj: {
                6: 'maskData_item_icon7',
                7: 'maskData_item_icon',
                8: 'maskData_item_icon5',
                9: 'maskData_item_icon4',
                10: 'maskData_item_icon3',
                11: 'maskData_item_icon2',
                41: 'maskData_item_icon6'
            },
            navData: [],
            messageVisible: false,
            firstData: [],
            secondData: [],
            thirdData: [],
            fouthData: [],
            fifthData: [],
            sixthData: [],
            seventhData: [],
            eightData: [],
            adList: [],
            adList2: []

        }
    }

    componentDidMount() {
        this.getMenuData({})
        
        this.getHotPost()
        this.getHotBbsList({})
        this.getChoose()
        this.getAds()
    }

    getAds = () => {
        merchantsInfo.advertisementList({}).then(res => res.json())
            .then(result => {
                if (result.ret === 200) {
                    let apiData = result.data.filter(item => item.type === 10)
                    let apiData2 = result.data.filter(item => item.type === 13)

                    this.setState({
                        adList: apiData[0]?.path ? JSON.parse(apiData[0]?.path) : [{ firstItemUrl: '', picPath: '' }],
                        adList2: apiData2[0]?.path ? JSON.parse(apiData2[0]?.path) : [{ firstItemUrl: '', picPath: '' }],
                    })
                }
            })
    }

    getHotBbsList = async ({ e = 1 }) => {
        let listData = []
        let date = moment(moment().format('YYYY-MM-DD hh:mm:ss')).unix();
        let twentyHours = date - 86400
        let sevenDay = date - 604800
        let thirtyDay = date - 2592000
        switch (e) {
            case 1:
                listData = await this.getBbsDataByApi({
                    pageSize: 6,
                    sort: 2,
                    endTime: moment().format('YYYY-MM-DD HH:mm:ss'),
                    beginTime: moment(twentyHours * 1000).format('YYYY-MM-DD HH:mm:ss'),
                })
                break;
            case 2:
                listData = await this.getBbsDataByApi({
                    pageSize: 6,
                    sort: 2,
                    endTime: moment().format('YYYY-MM-DD HH:mm:ss'),
                    beginTime: moment(sevenDay * 1000).format('YYYY-MM-DD HH:mm:ss'),
                })
                break;
            case 3:
                listData = await this.getBbsDataByApi({
                    sort: 2,
                    pageSize: 6,
                    endTime: moment().format('YYYY-MM-DD HH:mm:ss'),
                    beginTime: moment(thirtyDay * 1000).format('YYYY-MM-DD HH:mm:ss'),
                })
                break;
            default:
                break;
        }
        this.setState({
            hotPostListData: listData.data.list
        })

    }

    getBbsDataByApi = async ({
        language = sessionStorage["language"],
        beginTime,
        categoryId,
        endTime,
        isHot,
        pageSize = 10,
        pageNum = 1,
        sort,
    }) => {
        const listData = await forum.forumListWeb({
            language,
            beginTime,
            endTime,
            categoryId,
            isHot,
            sort,
            pageSize,
            pageNum
        })
        const apiData = await listData.json()
        return apiData
    }

    handleFilter = () => {
        this.props.history.push('/bbspagelist')
    }

    getMenuData = ({ parentId = 0, language = sessionStorage['language'] }) => {
        forum.forumCategoryListWeb({
            parentId,
            language
        })
            .then(res => res.json())
            .then(result => {
                console.log('result', result)
                if (result.ret === 200) {
                    const temp = result.data.sort((it, it2) => {
                        return it2.id - it.id
                    })
                    for (let i in temp) {
                        temp[i].iconid = 'bbs' + temp[i].id
                        temp[i].title = temp[i].categoryName
                        temp[i].subTitle = temp[i]?.children?.length > 0 ? temp[i]?.children[0]?.categoryName : ''
                        temp[i].subTitle2 = temp[i]?.children?.length > 1 ? temp[i]?.children[1]?.categoryName : ''
                    }

                    this.setState({
                        navData: result.data.sort((it, it2) => {
                            return it.id - it2.id
                        }),
                        menuArray: temp,
                        normalData: result.data.map(item => {
                            return {
                                id: item.id,
                                title: item.categoryName,
                                children: []
                            }
                        })
                    }, () => {
                        this.getBbsData()
                    })

                }
            })
    }

    getMenuId = (e, e2) => {
        console.log('eids', e, e2)
        sessionStorage['MAINTYPE'] = e
        sessionStorage['SECONDTYPE'] = e2
        this.props.history.push('/bbspagelist')
    }

    handleChange = (e) => {
        this.setState({
            hotPost: e
        }, () => {
            this.getHotBbsList({ e })
        })
    }

    // 置顶帖子
    getHotPost = async () => {
        let listData = await this.getBbsDataByApi({
            isHot: 1,
            pageSize: 10
        })
        console.log('listData.data.list=====》 top', listData.data.list)
        this.setState({
            hotData: listData.data.list
        })
    }

    // 精选热帖
    getChoose = async () => {
        let listData = await this.getBbsDataByApi({
            sort: 2,
            pageSize: 10
        })
        console.log('listData.data.list2', listData.data.list)
        this.setState({
            hotData: listData.data.list
        })
    }

    // 多种帖子
    getBbsData = async () => {
        let listData = await this.getBbsDataByApi({
            pageSize: 44
        })
        let temp = this.state.normalData
        let arr = listData.data.list
        for (let i in temp) {
            for (let j in arr) {
                if (temp[i].id === arr[j].categoryId) {
                    temp[i].children.push(arr[j])
                }
            }
        }

        const firstData =  await this.getBbsDataByApi({
            pageSize: 10,
            pageNum: 1,
            categoryId: this.state?.normalData[0] ?  this.state?.normalData[0]?.id : ''
        })
        this.setState({
            bbsData: temp,
            phoneData: temp,
            firstData,
           
        })
        const secondData  =  await this.getBbsDataByApi({
            pageSize: 10,
            pageNum: 1,
            categoryId: this.state?.normalData[1]?.id
        })

        this.setState({
            secondData
        })

        const thirdData = await this.getBbsDataByApi({
            pageSize: 10,
            pageNum: 1,
            categoryId: this.state?.normalData[2]?.id
        })

        this.setState({
            thirdData
        })

        const fouthData =  await this.getBbsDataByApi({
            pageSize: 10,
            pageNum: 1,
            categoryId: this.state?.normalData[3]?.id
        })

        this.setState({
            fouthData
        })

        const fifthData =  await this.getBbsDataByApi({
            pageSize: 10,
            pageNum: 1,
            categoryId: this.state?.normalData[4]?.id
        })

        this.setState({
            fifthData
        })

        const sixthData = await this.getBbsDataByApi({
            pageSize: 10,
            pageNum: 1,
            categoryId: this.state?.normalData[5]?.id
        })

        this.setState({
            sixthData
        })
        
        const seventhData = await this.getBbsDataByApi({
            pageSize: 10,
            pageNum: 1,
            categoryId: this.state?.normalData[6]?.id
        })

        this.setState({
            seventhData
        })
       

        
        console.log('this.state.firstData', this.state.firstData)
        console.log('bbsData', temp)
    }


    contentData = (listData, menuItem, nth) => {
        // console.log('listData', listData)
        if (!listData?.data?.list?.length === 0) {
            return 
        }
        return (
            //  eslint-disable-next-line array-callback-return
            <div className="bbs_main_content_context">
                {
                    this.judgeTop(menuItem)
                }
                <div className="bbs_main_content_top_column">
                    <div className="bbs_main_content_top_column_item">
                        <div className="bbs_main_content_top_column_item_text">{intl.get('BIAOTIE')}</div>
                    </div>
                    <div className="bbs_main_content_top_column_item">{intl.get('ZUOZHESHIJIAN')}</div>
                    <div className="bbs_main_content_top_column_item">{intl.get('HUIFUCHAKAN')}</div>
                </div>

                {
                    listData?.data?.list.map((item2, index2) => {
                        return (
                            <div className="bbs_main_content_context_item" key={index2} >

                                <div className="bbs_main_content_context_item_top" onClick={this.handleToDetail.bind(this, item2.id)}>
                                    <div className="bbs_main_content_context_item_top_item">
                                        {item2.mainTitle}<span className="bbs_main_content_top_row_item_num">[ {item2.clickNum}]</span>
                                        {
                                            this.judgeIsExtentd(item2)
                                        }
                                        {
                                            this.weatherPath(item2)
                                        }
                                    </div>
                                    <div className="bbs_main_content_context_item_top_item">
                                        <div>
                                            {item2.customerName}
                                        </div>
                                        <div>{timeFormat(item2.createDate)}</div>
                                    </div>
                                    <div className="bbs_main_content_context_item_top_item">
                                        <span className="bbs_main_content_top_row_item_arr">{item2.forumReplyVos ? item2.forumReplyVos.length : 0}</span>/{item2.clickNum}


                                    </div>
                                </div>

                                <div className="bbs_main_content_context_item_content">
                                    <div className="bbs_main_content_context_item_content_text" onClick={this.handleToDetail.bind(this, item2.id)}>
                                        <div className="bbs_main_content_context_item_content_text_content">
                                            <div className="bbs_main_content_context_item_content_text" dangerouslySetInnerHTML={{ __html: item2.context }}></div>
                                        </div>

                                        <div className="bbs_main_content_context_item_content_seemore">[{intl.get('CHAKANGENGDUO')}]</div>

                                    </div>
                                    <div className="bbs_main_content_context_item_content_imgs">


                                        {
                                            item2.path?.split(",")?.map((item3, index3) => {
                                                return (
                                                    <div className="bbs_main_content_context_item_content_imgs_item" key={index3}>
                                                        <Image

                                                            preview={true}
                                                            src={item3}
                                                            fallback="data:image/png;base64,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"
                                                        />
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            </div>
                        )
                    })
                }

                <div style={{ width: '100%', textAlign: 'center', padding: '0.12rem 0', background: '#fff' }}>
                    <APagination pageNum={listData?.data?.pageNum} total={listData?.data?.totalCount} current={1} changePage={this.handleChangePage.bind(this, nth)} weatherTop={true} />
                </div>
            </div>


        )
    }


    handleChangePage = async (nth, page, pageSize) => {
        // console.log('page', nth, page, pageSize)
        switch (Number(nth)) {
            case 1:
                this.setState({
                    firstData: await this.getBbsDataByApi({
                        pageSize: pageSize,
                        pageNum: page,
                        categoryId: this.state.normalData[0].id
                    }),
                })
                break;
            case 2:
                this.setState({
                    secondData: await this.getBbsDataByApi({
                        pageSize: pageSize,
                        pageNum: page,
                        categoryId: this.state.normalData[1].id
                    }),
                })
                break;
            case 3:
                this.setState({
                    thirdData: await this.getBbsDataByApi({
                        pageSize: pageSize,
                        pageNum: page,
                        categoryId: this.state.normalData[2].id
                    })
                })
                break;

            case 4:
                this.setState({
                    fouthData: await this.getBbsDataByApi({
                        pageSize: pageSize,
                        pageNum: page,
                        categoryId: this.state.normalData[3].id
                    })
                })
                break;

            case 5:
                this.setState({
                    fifthData: await this.getBbsDataByApi({
                        pageSize: pageSize,
                        pageNum: page,
                        categoryId: this.state.normalData[4].id
                    }),
                })
                break;

            case 6:
                this.setState({
                    sixthData: await this.getBbsDataByApi({
                        pageSize: pageSize,
                        pageNum: page,
                        categoryId: this.state.normalData[5].id
                    }),
                })
                break;

            case 7:
                this.setState({
                    seventhData: await this.getBbsDataByApi({
                        pageSize: pageSize,
                        pageNum: page,
                        categoryId: this.state.normalData[6].id
                    }),
                })
                break;
            default:
                break;
        }

    }




    judgeTop = (item) => {
        switch (item?.id) {
            case 41:
                return (
                    <div className="bbs_main_content_context_top_green">
                        <div className="bbs_main_content_context_top_green_left">
                            <Icon component={friends} style={{ fontSize: '.20rem', paddingRight: '.12rem', color: '#ffffff' }} className="init-icons" />
                            {item.title}
                        </div>
                        <div className="bbs_main_content_context_top_green_right" onClick={this.handleToList.bind(this, item)}>
                            {intl.get('CHAKANGENGDUO')}
                        </div>
                    </div>
                )

            case 11:
                return (
                    <div className="bbs_main_content_context_top_blue">
                        <div className="bbs_main_content_context_top_green_left">
                            <Icon component={secondhand} style={{ fontSize: '.20rem', paddingRight: '.12rem', color: '#ffffff' }} className="init-icons" />
                            {item.title}
                        </div>
                        <div className="bbs_main_content_context_top_green_right" onClick={this.handleToList.bind(this, item)}>
                            {intl.get('CHAKANGENGDUO')}

                        </div>
                    </div>
                )
            case 10:
                return (
                    <div className="bbs_main_content_context_top_green">
                        <div className="bbs_main_content_context_top_green_left">
                            <Icon component={car} style={{ fontSize: '.20rem', paddingRight: '.12rem', color: '#ffffff' }} className="init-icons" />
                            {item.title}
                        </div>
                        <div className="bbs_main_content_context_top_green_right" onClick={this.handleToList.bind(this, item)}>
                            {intl.get('CHAKANGENGDUO')}

                        </div>
                    </div>
                )

            case 9:
                return (
                    <div className="bbs_main_content_context_top_blue">
                        <div className="bbs_main_content_context_top_green_left">
                            <Icon component={buessiness} style={{ fontSize: '.20rem', paddingRight: '.12rem', color: '#ffffff' }} className="init-icons" />
                            {item.title}
                        </div>
                        <div className="bbs_main_content_context_top_green_right" onClick={this.handleToList.bind(this, item)}>
                            {intl.get('CHAKANGENGDUO')}

                        </div>
                    </div>
                )
            case 8:
                return (
                    <div className="bbs_main_content_context_top_green">
                        <div className="bbs_main_content_context_top_green_left">
                            <Icon component={house} style={{ fontSize: '.20rem', paddingRight: '.12rem', color: '#ffffff' }} className="init-icons" />
                            {item.title}
                        </div>
                        <div className="bbs_main_content_context_top_green_right" onClick={this.handleToList.bind(this, item)}>
                            {intl.get('CHAKANGENGDUO')}

                        </div>
                    </div>
                )
            case 7:
                return (
                    <div className="bbs_main_content_context_top_blue">
                        <div className="bbs_main_content_context_top_green_left">
                            <Icon component={renthome} style={{ fontSize: '.20rem', paddingRight: '.12rem', color: '#ffffff' }} className="init-icons" />
                            {item.title}
                        </div>
                        <div className="bbs_main_content_context_top_green_right" onClick={this.handleToList.bind(this, item)}>
                            {intl.get('CHAKANGENGDUO')}

                        </div>
                    </div>
                )
            case 6:
                return (
                    <div className="bbs_main_content_context_top_green">
                        <div className="bbs_main_content_context_top_green_left">
                            <Icon component={job} style={{ fontSize: '.20rem', paddingRight: '.12rem', color: '#ffffff' }} className="init-icons" />
                            {item.title}
                        </div>
                        <div className="bbs_main_content_context_top_green_right" onClick={this.handleToList.bind(this, item)}>
                            {intl.get('CHAKANGENGDUO')}

                        </div>
                    </div>
                )
            default:
                break;
        }

    }

    handleToDetail = (e) => {
        sessionStorage['BBSTOPICID'] = e
        let urlParms = JSON.stringify(e)
        this.props.history.push(`/bbspagedetail/${urlParms}`)
    }

    handleToList = (item) => {
        sessionStorage['MAINTYPE'] = item.id ? item.id : ''
        sessionStorage['SECONDTYPE'] = ''
        this.props.history.push('/bbspagelist')
    }

    handleGotoNewBbs = () => {
        if (!JSON.parse(sessionStorage.getItem("USERDATA"))) {
            message.warning(intl.get('QINGXIANDENGLU'))
            return
        }
        this.props.history.push('/bbspagenew')
    }

    weatherPath = (item) => {
        if (!item.path) {
            return
        } else {
            return (
                <Icon component={img} style={{ fontSize: '.16rem', paddingLeft: '.12rem', color: '#ffffff' }} className="init-icons" />
            )
        }
    }

    // 移动端
    handleChangeNav = (val) => {
        console.log('val', val)
        sessionStorage['NAVITEM'] = val
        sessionStorage['MAINTYPE'] = ''
        sessionStorage['SECONDTYPE'] = ''
        sessionStorage['CITY'] = ''

        this.setState({})
        switch (Number(val)) {
            case 1:
                this.props.history.push('/main')
                break;
            case 2:
                this.props.history.push('/yellowpages')
                break;
            case 3:
                this.props.history.push('/bbspages')
                break;
            case 4:
                this.props.history.push('/merchantsettled')
                break;
            case 5:
                if (!JSON.parse(sessionStorage.getItem("USERDATA"))) {
                    this.props.history.push('/login')
                } else {
                    this.props.history.push('/myplace')
                }
                break;
            default:
                break;

        }
    }

    handleGotoConnectUS = () => {
        this.props.history.push('/connectus')

    }
    changeLanguage = (val) => {
        if (val === 'zh-CN') {
            sessionStorage['language'] = 1
            sessionStorage['languageTitle'] = '简体中文'
            sessionStorage['languageFilter'] = val
        } else if (val === 'en-US') {
            sessionStorage['language'] = 2
            sessionStorage['languageTitle'] = 'English'
            sessionStorage['languageFilter'] = val
        } else if (val === 'zh-CH') {
            sessionStorage['language'] = 3
            sessionStorage['languageTitle'] = '繁體中文'
            sessionStorage['languageFilter'] = val
        }
        window.location.reload()
    }

    handleClickSelect = (e) => {
        sessionStorage['MAINTYPE'] = e
        let filterData = []
        if (e !== '') {
            filterData = this.state.bbsData.filter((item => {
                return item.id === e
            }))
        } else {
            filterData = this.state.bbsData
        }

        this.setState({
            phoneData: filterData
        })
    }
    handleSeeMore = () => {
        this.setState({
            visible1: !this.state.visible1
        })
    }
    showChoice = () => {
        if (sessionStorage['MAINTYPE'] === '' || !sessionStorage['MAINTYPE']) {
            return (
                <>
                    <div className="phone_bbs_gird_icons">
                        <div className="phone_bbs_gird_icons_item" onClick={this.handleToList.bind(this, { id: 7 })}>
                            <div className="phone_bbs_gird_icons_item_icon">
                                <div className="phone_bbs_gird_icons_item_icon_item"></div>
                            </div>
                            <div className="phone_bbs_gird_icons_item_title">{intl.get('FANGWUZULING')}</div>
                        </div>

                        <div className="phone_bbs_gird_icons_item" onClick={this.handleToList.bind(this, { id: 6 })}>
                            <div className="phone_bbs_gird_icons_item_icon">
                                <div className="phone_bbs_gird_icons_item_icon_item2"></div>
                            </div>
                            <div className="phone_bbs_gird_icons_item_title">{intl.get('QIUZHIZHAOPING')}</div>
                        </div>


                        <div className="phone_bbs_gird_icons_item" onClick={this.handleToList.bind(this, { id: 11 })}>
                            <div className="phone_bbs_gird_icons_item_icon">
                                <div className="phone_bbs_gird_icons_item_icon_item3"></div>
                            </div>
                            <div className="phone_bbs_gird_icons_item_title">{intl.get('ERSHOUSHICHANG')}</div>
                        </div>

                        <div className="phone_bbs_gird_icons_item" onClick={this.handleSeeMore}>
                            <div className="phone_bbs_gird_icons_item_icon">
                                <div className="phone_bbs_gird_icons_item_icon_item4"></div>
                            </div>
                            <div className="phone_bbs_gird_icons_item_title">{intl.get('QUANBU')}</div>
                        </div>
                    </div>

                    <Popup position='top' visible={this.state.visible1} bodyStyle={{ height: '100vh' }}>
                        <div className="phone_popup_contnet">
                            <CloseOutlined style={{ fontSize: '20px', padding: '20px' }} onClick={this.handleSeeMore} />

                            <div className="phone_popup_contnet_item">
                                {intl.get('YISHOULUNT')}
                            </div>

                            {
                                this.state?.bbsData?.map((item) => {
                                    return (
                                        <div className="phone_popup_contnet_item" key={item.id} onClick={this.handleToList.bind(this, item)}>
                                            {item.title}
                                        </div>
                                    )
                                })
                            }

                            <div className="phone_popup_contnet_item" onClick={this.handleShow}>
                                {intl.get('FATIE')}
                            </div>

                            <div className="phone_popup_contnet_item" onClick={this.handleGotoConnectUS}>
                                {intl.get('LIANXIWOMEN')}
                            </div>
                        </div>
                    </Popup>


                    <div className="phone_bbs_swipers">
                        <div className="phone_bbs_swipers">
                            <Swiper
                                autoplay
                            >

                                {
                                    this.state.adList2.map(((val, index) => {
                                        return (
                                            <Swiper.Item key={index}>
                                                <a href={val.firstItemUrl} target="_blank">
                                                    <div style={{ height: '150px', width: '100%',background: '#fff' }}>
                                                        <div style={{ width: '100%', height: '100%', background: `url(${val.picPath}) `, backgroundSize: 'contain', maxWidth: '100%', maxHeight: '100%', backgroundRepeat: 'no-repeat', backgroundPosition: 'center' }}>
                                                        </div>
                                                    </div>
                                                </a>
                                            </Swiper.Item >
                                        )
                                    }))
                                }

                            </Swiper>
                        </div>
                    </div>
                    <div className="phone_bbs_content">
                        <div className="phone_bbs_content_title">
                            <div className="phone_bbs_index_top_first_left_img"></div>
                            {intl.get('JINGXUANRETIE')}
                        </div>
                        <div className="phone_content_sort">
                            <div className="phone_content_sort_item">{intl.get('ZUIXIN')}</div>
                        </div>


                        {
                            this.state?.hotData?.map((item) => {
                                return (


                                    <div className="phone_content_item" key={item.id} >
                                        <div className="phone_content_item_top" onClick={this.handleToDetail.bind(this, item.id)}>
                                            <Avatar size={30} icon={<UserOutlined />} src={item.customerPath} />
                                            <div className="phone_content_item_title">
                                                <div className="phone_content_item_title_text">{item.customerName}</div>
                                                <div className="phone_content_item_title_time"> {timeFormat(item.createDate)}</div>
                                            </div>



                                            {this.judgeIsTop(item.isHot)}



                                        </div>
                                        <div className="phone_content_item_title_text" onClick={this.handleToDetail.bind(this, item.id)}>{item.mainTitle} {this.judgeIsExtentd(item)}</div>
                                        <div className="phone_content_item_context" dangerouslySetInnerHTML={{ __html: item.context }} onClick={this.handleToDetail.bind(this, item.id)}></div>
                                        <span className="see_more" onClick={this.handleToDetail.bind(this, item.id)}>{'....' + intl.get('CHAKANGENGDUO')}</span>

                                        <div className="phone_content_item_imgs">
                                            {
                                                item.path?.split(",")?.map((item2, index2) => {
                                                    return (
                                                        <div className="phone_content_item_imgs_item" key={index2}>
                                                            <Image

                                                                preview={true}
                                                                src={item2}
                                                                fallback="data:image/png;base64,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"
                                                            />
                                                        </div>
                                                    )
                                                })
                                            }


                                        </div>
                                    </div>
                                )

                            })
                        }
                    </div>
                </>
            )
        }

    }


    judgeIsTop = (val) => {
        if (val === 1) {
            return (
                <div className="phone_content_item_tag">
                    <div className="phone_content_item_tag_btn">
                        {intl.get('ZHIDING')}
                    </div>
                </div>
            )
        } else {
            return (
                <div className="phone_content_item_tag">

                </div>
            )
        }
    }

    handleFocus = (e) => {
        this.setState({
            popvisible: true
        })
        this.$phoneSearchEvent.searchFocus()

    }


    searchEvevnt = (element) => {
        this.$phoneSearchEvent = element
    }

    handleSetVisible = (e) => {
        this.setState({
            popvisible: false
        })
    }

    handleShow = () => {
        this.setState({
            maskVisible: !this.state.maskVisible,
            visible1: false
        })
    }

    handleGotoNew = (e) => {
        console.log('e', e)

        if (!JSON.parse(sessionStorage.getItem("USERDATA"))) {
            message.warning(intl.get('QINGXIANDENGLU'))
            return
        }
        sessionStorage['BBSCATEGORYID'] = e
        this.props.history.push('/bbspagenew')
    }


    handleGotoPerson = () => {
        if (!JSON.parse(sessionStorage.getItem("USERDATA"))) {
            this.props.history.push('/login')
        } else {
            this.props.history.push('/myplace')

        }
    }


    handleSeeMessage = () => {
        this.setState({
            messageVisible: true
        })
    }

    getListClose = () => {
        this.setState({
            messageVisible: false
        })
    }

    judgeIsExtentd = (item) => {
        if (item.isExtend === 1) {
            return (
                <span className="bbs_main_content_top_row_item_num">{intl.get('TUIGUANG')}</span>
            )
        }
    }

    
    handleGotoMain = () => {
        this.props.history.push({ pathname: '/main' })
    }
    // // 此事件接收子对象
    // searchEvevnt = childDate => {
    //     this.$searchchild = childDate;
    // };
    render() {
        document.title = "EQLD昆士兰易搜论坛BBS";
        document.querySelector('meta[property="og:title"]').setAttribute('content', 'EQLD昆士兰易搜论坛BBS');
        document.querySelector('meta[property="og:description"]').setAttribute('content', '找租房、找生意，找房源，找工作，找二手，选易搜！');
        document.querySelector('meta[itemprop="description"]').setAttribute('content', '找租房、找生意，找房源，找工作，找二手，选易搜！');
        document.querySelector('meta[property="og:type"]').setAttribute('content', 'website');
        document.querySelector('meta[property="og:image"]').setAttribute('content', 'http://icon.mobanwang.com/UploadFiles_8971/200910/20091011134333685.png');
        document.querySelector('meta[itemprop="image"]').setAttribute('content', 'http://icon.mobanwang.com/UploadFiles_8971/200910/20091011134333685.png');
        document.querySelector('meta[itemprop="name"]').setAttribute('content', 'EQLD昆士兰易搜论坛BBS');
        return (
            <>
                <div className="main_content">
                    <Nav history={this.props.history} props={this.props} />
                    <Banner type="2" history={this.props.history} setBannerSearch={this.handleFilter} />
                    <BreadCrumb history={this.props.history} breadData={this.state.breadArray} />
                    <div className="bbs_menu">
                        <div className="bbs_menu_left">
                            <Menus menuData={this.state.menuArray} history={this.props.history} setMenuId={this.getMenuId}  menuType={2}/>
                        </div>
                        <div className="bbs_menu_right">
                            <div className="bbs_menu_right_top">
                                <div className="bbs_menu_right_top_item">
                                    <div className="bbs_menu_right_top_item_top">
                                        <div>
                                            <Icon component={desktop} style={{ fontSize: '.24rem', color: 'white' }} className="init-icons" />
                                        </div>
                                        <div className="bbs_menu_right_top_item_top_name">{intl.get('RETIEPAIHANGHBAN')}</div>
                                    </div>
                                    <div className="bbs_menu_right_top_item_middle">
                                        <div className={`${this.state.hotPost === 1 ? "bbs_menu_right_top_item_middle_item_active" : "bbs_menu_right_top_item_middle_item customer_hover"}`} onClick={this.handleChange.bind(this, 1)}>
                                            {intl.get('ERSHISIXIAOS')}
                                        </div>
                                        <div className={`${this.state.hotPost === 2 ? "bbs_menu_right_top_item_middle_item_active" : "bbs_menu_right_top_item_middle_item customer_hover"}`} onClick={this.handleChange.bind(this, 2)}>
                                            {intl.get('JINQITIAN')}
                                        </div>
                                        <div className={`${this.state.hotPost === 3 ? "bbs_menu_right_top_item_middle_item_active" : "bbs_menu_right_top_item_middle_item customer_hover"}`} onClick={this.handleChange.bind(this, 3)}>
                                            {intl.get('SANSHITIANNEI')}
                                        </div>

                                    </div>
                                    <div className="bbs_menu_right_top_item_bottom">
                                        {
                                            this.state.hotPostListData.map((item, index) => {
                                                return (
                                                    <div className="bbs_menu_right_top_item_bottom_item" key={item.id} onClick={this.handleToDetail.bind(this, item.id)}>{index + 1}. {item.mainTitle}</div>
                                                )
                                            })
                                        }

                                    </div>
                                </div>

                                <div className="bbs_menu_right_top_item2">
                                    <a href={this.state.adList[0]?.firstItemUrl} target="_blank">
                                        <Image
                                            width='3.86rem'
                                            height='2.97rem'
                                            preview={false}
                                            src={this.state.adList[0]?.picPath}
                                        />
                                    </a>
                                </div>

                            </div>
                            <div className="bbs_menu_right_bottom">
                                <div className="bbs_menu_right_bottom_item">
                                    <a href={this.state.adList[1]?.firstItemUrl} target="_blank">
                                        <Image
                                            width='3.86rem'
                                            height='1.88rem'
                                            preview={false}
                                            src={this.state.adList[1]?.picPath}
                                        />
                                    </a>
                                </div>
                                <div className="bbs_menu_right_bottom_item">
                                    <a href={this.state.adList[2]?.firstItemUrl} target="_blank">
                                        <Image
                                            width='3.86rem'
                                            height='1.88rem'
                                            preview={false}
                                            src={this.state.adList[2]?.picPath}
                                        />
                                    </a>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div className="bbs_main_content">
                        {/* <div className="bbs_main_content_top">
                            <div className="bbs_main_content_top_new">
                                <div className="bbs_main_content_top_new_button" onClick={this.handleGotoNewBbs}>
                                    <Icon component={bird} style={{ fontSize: '.16rem', paddingRight: '.12rem' }} className="init-icons" />
                                    {intl.get('FABIAOXINTIE')}
                                </div>
                            </div>
                            <div className="bbs_main_content_top_column">
                                <div className="bbs_main_content_top_column_item">
                                    <div className="bbs_main_content_top_column_item_text">{intl.get('ZHIDING')}</div>
                                </div>
                                <div className="bbs_main_content_top_column_item"> {intl.get('ZUOZHESHIJIAN')}</div>
                                <div className="bbs_main_content_top_column_item"> {intl.get('HUIFUCHAKAN')}</div>
                            </div>

                            {
                                this.state.topData.map((item, index) => {
                                    return (
                                        <div className="bbs_main_content_top_row" key={index} onClick={this.handleToDetail.bind(this, item.id)}>
                                            <div className="bbs_main_content_top_row_item">
                                                <Icon component={arrow} style={{ fontSize: '.14rem', paddingRight: '.12rem', color: '#56C6F1' }} className="init-icons" />
                                                {item.mainTitle}
                                                <span className="bbs_main_content_top_row_item_num">[{item.clickNum}]</span>
                                                {
                                                    this.judgeIsExtentd(item)
                                                }

                                                {
                                                    this.weatherPath(item)
                                                }
                                            </div>
                                            <div className="bbs_main_content_top_row_item">
                                                <div>
                                                    {item.customerName}
                                                </div>
                                                <div>{timeFormat(item.createDate)}</div>
                                            </div>
                                            <div className="bbs_main_content_top_row_item">
                                                <span className="bbs_main_content_top_row_item_arr">{item.replyNum}</span>/{item.clickNum}
                                            </div>
                                        </div>
                                    )
                                })
                            }

                        </div> */}



                        <div className="bbs_main_content_context">
                            <div className="bbs_main_content_context_top"> {intl.get('JINGXUANRETIE')}</div>

                            {
                                this.state?.hotData?.map((item, index) => {
                                    return (
                                        <div className="bbs_main_content_context_item" key={index} >
                                            <div className="bbs_main_content_context_item_top" onClick={this.handleToDetail.bind(this, item.id)}>
                                                <div className="bbs_main_content_context_item_top_item">
                                                    {item.mainTitle}
                                                    <span className="bbs_main_content_top_row_item_num">[{item.clickNum}]</span>
                                                    {
                                                        this.judgeIsExtentd(item)
                                                    }
                                                    {
                                                        this.weatherPath(item)
                                                    }
                                                </div>
                                                <div className="bbs_main_content_context_item_top_item">
                                                    <div>
                                                        {item.customerName}
                                                    </div>
                                                    <div>{timeFormat(item.createDate)}</div>
                                                </div>
                                                <div className="bbs_main_content_context_item_top_item">
                                                    <span className="bbs_main_content_top_row_item_arr">{item.replyNum}</span>/{item.clickNum}

                                                </div>
                                            </div>
                                            <div className="bbs_main_content_context_item_content">
                                                <div className="bbs_main_content_context_item_content_text" onClick={this.handleToDetail.bind(this, item.id)}>
                                                    <div className="bbs_main_content_context_item_content_text_content">
                                                        <div className="bbs_main_content_context_item_content_text" dangerouslySetInnerHTML={{ __html: item.context }}></div>
                                                    </div>

                                                    <div className="bbs_main_content_context_item_content_seemore">[{intl.get('CHAKANGENGDUO')}]</div>

                                                </div>

                                                <div className="bbs_main_content_context_item_content_imgs">
                                                    {
                                                        item.path?.split(",")?.map((item2, index2) => {
                                                            return (
                                                                <div className="bbs_main_content_context_item_content_imgs_item" key={index2}>
                                                                    <Image

                                                                        preview={true}
                                                                        src={item2}
                                                                        fallback="data:image/png;base64,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"
                                                                    />
                                                                </div>
                                                            )
                                                        })
                                                    }

                                                </div>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>


                        {
                            this.contentData(this.state.firstData, this.state.menuArray[0], '1')
                        }

                        {
                            this.contentData(this.state.secondData, this.state.menuArray[1], '2')
                        }

                        {
                            this.contentData(this.state.thirdData, this.state.menuArray[2], '3')
                        }

                        {
                            this.contentData(this.state.fouthData, this.state.menuArray[3], '4')
                        }

                        {
                            this.contentData(this.state.fifthData, this.state.menuArray[4], '5')
                        }

                        {
                            this.contentData(this.state.sixthData, this.state.menuArray[5], '6')
                        }

                        {
                            this.contentData(this.state.seventhData, this.state.menuArray[6], '7')
                        }



                    </div>

                    <AdConsult industyData={this.state.menuArray} />
                    <Foot history={this.props.history} />
                    <LeftTool history={this.props.history} />

                </div>
                {/* 移动端==============================================================================================================================================================================================================================> */}

                <div className="phone_content bbs_phone_content">
                    <div className="phone_bbs_index_top">
                        <div className="phone_bbs_index_top_first">
                            <div className="phone_bbs_index_top_first_left">
                                <div className="phone_bbs_index_top_first_left_img"></div>
                                <span className="phone_bbs_index_top_first_left_text">{intl.get('YISHOULUNT')} {intl.get('FUWUYUAOZHOU')}</span>
                            </div>
                            <div className="phone_bbs_index_top_first_right" onClick={this.handleGotoMain}></div>
                        </div>

                        <div className="phone_bbs_index_search">
                            <div className="phone_bbs_index_search_avatar">
                                <Avatar size={40} icon={<UserOutlined />} src={sessionStorage.getItem("USERDATA") ? JSON.parse(sessionStorage.getItem("USERDATA"))?.customer?.path : ''} onClick={this.handleGotoPerson} />
                            </div>
                            <div className="phone_bbs_index_search_input">
                                <Search placeholder={intl.get('KUNSHILANYISHOU')} className="phone_bbs_index_search_input_item" onFocus={this.handleFocus} />


                                <PopupSearch visible={this.state.popvisible} type="2" history={this.props.history} setVisible={this.handleSetVisible} searchEvevnt={this.searchEvevnt} />



                            </div>
                            <div className="phone_bbs_index_search_icons">
                                <div className="phone_bbs_index_search_icons_item">
                                    <MailFill fontSize={20} onClick={this.handleSeeMessage} />
                                    <PhoneChatList messageVisible={this.state.messageVisible} listClose={this.getListClose} />
                                </div>
                                <div className="phone_bbs_index_search_icons_item">

                                    <Dropdown>
                                        <Dropdown.Item key='sorter' title={<><GlobalOutline fontSize={20} /></>}>
                                            <div style={{ padding: 12 }}>
                                                <div className="sorter_item2" onClick={this.changeLanguage.bind(this, "zh-CN")}>
                                                    {intl.get('JIANTIZHONGWEN')}
                                                    <RightOutlined />
                                                </div>
                                                <div className="sorter_item2" onClick={this.changeLanguage.bind(this, "en-US")}>
                                                    {intl.get('ENGLISH')}
                                                    <RightOutlined />
                                                </div>
                                                <div className="sorter_item2" onClick={this.changeLanguage.bind(this, "zh-CH")}>
                                                    {intl.get('FANTIZHONGWEN')}
                                                    <RightOutlined />
                                                </div>
                                            </div>
                                        </Dropdown.Item>
                                    </Dropdown>
                                </div>
                                <div className="phone_bbs_index_search_icons_item">
                                    <Dropdown>
                                        <Dropdown.Item key='sorter' title={<><AppstoreOutline fontSize={20} /></>}>
                                            <div className="sorterList" style={{ padding: 12 }}>
                                                <div className="sorter_item" onClick={this.handleChangeNav.bind(this, 1)}>
                                                    {intl.get('SHOUYE')}
                                                </div>
                                                <div className="sorter_item" onClick={this.handleChangeNav.bind(this, 2)}>
                                                    {intl.get('SHANGJIAHUANG')}
                                                </div>
                                                <div className="sorter_item" onClick={this.handleChangeNav.bind(this, 3)}>
                                                    {intl.get('YISHOULUNT')}
                                                </div>
                                                <div className="sorter_item" onClick={this.handleChangeNav.bind(this, 4)}>
                                                    {intl.get('SHANGJAIRUZHU')}
                                                </div>
                                                <div className="sorter_item" onClick={this.handleChangeNav.bind(this, 5)}>
                                                    {intl.get('WODEYISOU')}
                                                </div>
                                            </div>
                                        </Dropdown.Item>
                                    </Dropdown>
                                </div>
                            </div>
                        </div>
                        <div className="phone_bbs_index_tabs">
                            <div className="phone_bbs_index_tabs_item" onClick={this.handleClickSelect.bind(this, '')}>
                                <div className={!sessionStorage['MAINTYPE'] ? "phone_bbs_index_tabs_item_title_active" : "phone_bbs_index_tabs_item_title"} >  {intl.get('TUIJIANCAIFUWU')}</div>
                                <div className={!sessionStorage['MAINTYPE'] ? "phone_bbs_index_tabs_item_subtitle_active" : "phone_bbs_index_tabs_item_subtitle"} >{intl.get('WEINITUIJIAN')}</div>
                            </div>


                            {
                                this.state?.navData?.map((item) => {
                                    return (
                                        <div className="phone_bbs_index_tabs_item" key={item.id} onClick={this.handleClickSelect.bind(this, item.id)}>
                                            <div className={Number(sessionStorage['MAINTYPE']) === item.id ? "phone_bbs_index_tabs_item_title_active" : "phone_bbs_index_tabs_item_title"} >{item.title}</div>
                                            <div className={Number(sessionStorage['MAINTYPE']) === item.id ? "phone_bbs_index_tabs_item_subtitle_active" : "phone_bbs_index_tabs_item_subtitle"}> {this.state.bbsTitleObj[item.id]}</div>
                                        </div>
                                    )
                                })
                            }


                        </div>


                    </div>

                    {
                        this.showChoice()
                    }




                    {
                        this.state?.phoneData?.map((item, index) => {
                            return (
                                <div className="phone_bbs_content" key={item.id} >
                                    <div className="phone_bbs_content_title">
                                        <div className="phone_bbs_index_top_first_left_img"></div>
                                        {item.title}
                                    </div>
                                    <div className="phone_content_sort">
                                        <div className="phone_content_sort_item">{intl.get('ZUIXIN')}</div>
                                    </div>


                                    {
                                        item?.children?.map((item2, index2) => {
                                            return (
                                                <div className="phone_content_item" key={index2} onClick={this.handleToDetail.bind(this, item2.id)}>
                                                    <div className="phone_content_item_top">
                                                        <Avatar size={30} icon={<UserOutlined />} src={item2.customerPath} />
                                                        <div className="phone_content_item_title">
                                                            <div className="phone_content_item_title_text">{item2.customerName}</div>
                                                            <div className="phone_content_item_title_time">  -- {timeFormat(item2.createDate)}</div>
                                                        </div>

                                                        <div className="phone_content_item_tag">
                                                            <div className="phone_content_item_tag_btn_none">

                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="phone_content_item_title_text">{item2.mainTitle} {this.judgeIsExtentd(item2)}</div>
                                                    <div className="phone_content_item_context" dangerouslySetInnerHTML={{ __html: item2.context }}></div>




                                                    <span className="see_more">{'....' + intl.get('CHAKANGENGDUO')}</span>
                                                </div>
                                            )

                                        })
                                    }
                                </div>
                            )
                        })
                    }



                    <div className="phone_post_bbs">
                        <div className="phone_post_bbs_item" onClick={this.handleShow}>
                            <div className="phone_post_bbs_item_icon">
                                <EditOutlined />
                            </div>
                            <div className="phone_post_bbs_item_title">{intl.get('FATIE')}</div>
                        </div>
                        <Mask visible={this.state.maskVisible} opacity={0.8} >
                            <div className="maskData">
                                {
                                    this.state?.navData.map((item) => {
                                        return (
                                            <div className="maskData_item" key={item.id} onClick={this.handleGotoNew.bind(this, item.id)}>
                                                <div className="maskData_item_left">
                                                    <div className={this.state.newBbsObj[item.id]}></div>

                                                </div>
                                                <div className="maskData_item_title">{item.title}</div>

                                            </div>
                                        )
                                    })
                                }
                                <div className="maskData_item">
                                    <CloseCircleFilled style={{ fontSize: '40px', color: '#fff' }} onClick={this.handleShow} />
                                </div>
                            </div>
                        </Mask>
                        <div className="phone_post_bbs_item" onClick={this.handleGotoConnectUS}>
                            <div className="phone_post_bbs_item_icon">
                                <MobileOutlined />
                            </div>
                            <div className="phone_post_bbs_item_title" >{intl.get('LIANXIWOMEN')}</div>
                        </div>
                    </div>


                </div>
            </>
        )
    }


}